import { Component } from '@angular/core';
import { InsuranceFlexWrapper } from '@app/pages/quote/insurance/insurance-flex/insurance-flex-wrapper.component';
import { ActivatedRoute } from '@angular/router';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';

@Component({
  selector: 'app-insurance-flex',
  templateUrl: './insurance-flex-desktop.component.html',
  styleUrls: ['./insurance-flex-desktop.component.css'],
})
export class InsuranceFlexComponent extends InsuranceFlexWrapper {
  constructor(
    route: ActivatedRoute,
    menu: MenusServices,
    notification: NotificationService
  ) {
    super(route, menu, notification);
  }
}
